import { put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { logout } from '..';
import { clearCookie, COOKIES } from 'src/utils/cookie';
import { handleErrorSaga } from 'src/utils/handleErrorSaga';
import { redirectToHome } from 'src/utils/router';

export function* logoutSaga(): SagaIterator {
  try {
    yield call(clearCookie, COOKIES.AUTH_SERVICE_TOKEN);
    yield put(logout());
    yield call(redirectToHome);
  } catch (err) {
    yield call(handleErrorSaga, err);
  }
}
